<section class="text-content" *ngIf="text">
  <div class="container">
    <div class="wrapper">
      <div class="content-text" [innerHTML]="text"></div>
    </div>
  </div>
</section>
